<template>
  <BaseListItem :class="[focus ? 'bg-blue-200' : '']">
    <div class="flex -mx-3 p-4">
      <div class="w-24 px-3">
        <template v-if="account && account.logo">
          <img :src="account.logo" class="block rounded w-full" />
        </template>
        <template v-else>
          <div class="aspect-ratio-square w-full rounded bg-gray-200" />
        </template>
      </div>
      <div class="flex-1 px-3">
        <a role="button" @click="editContact">
          {{ contactRequest.fullName }}
        </a>
        <div class="my-1">
          <span
            v-if="typeof contactRequest.unsubscribeRequestId === 'string'"
            class="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800"
            >{{ $t('global.unsubscribed') }}</span
          >
        </div>
        <p class="text-sm font-medium text-gray-600 tracking-wide">
          <a :href="`mailto:${contactRequest.email}`">{{ contactRequest.email }}</a>
          &bull;

          <a v-if="hasValidPhoneFormat" :href="`tel:+30${contactRequest.phone}`"
            >{{ contactRequest.phone }}
          </a>
          <span v-else>{{ contactRequest.phone }}</span>
        </p>
      </div>
      <div class="flex-1 px-3">
        <p>
          <RouterLink
            v-if="project"
            :to="{
              name: 'accounts.projects.project',
              params: {
                accountId: contactRequest.accountId,
                projectId: project.uuid,
              },
            }"
          >
            {{ project.name }}
          </RouterLink>
          <span v-else>-</span>
        </p>
        <p>
          <span v-if="pipelineStage">{{ pipelineStage.name }}</span>
          <span v-else>-</span>
        </p>
      </div>

      <div class="w-48 px-3 text-right">
        <p>
          {{ createdAtFromNow }}
        </p>
        <p class="text-sm text-gray-600">
          {{ createdAt }}
        </p>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    contactRequest: { type: Object, required: true },
    focus: Boolean,
  },

  computed: {
    project() {
      if (!this.contactRequest.projectId) {
        return null;
      }

      return this.$store.state.entities.projects.byId[this.contactRequest.projectId] || null;
    },
    pipelineStage() {
      if (!this.contactRequest.pipelineStageId) {
        return null;
      }

      return (
        this.$store.state.entities.pipelineStages.byId[this.contactRequest.pipelineStageId] || null
      );
    },
    account() {
      if (!this.contactRequest.accountId) {
        return null;
      }

      return this.$store.state.entities.accounts.byId[this.contactRequest.accountId] || null;
    },
    hasValidPhoneFormat() {
      if (!this.contact || !this.contactRequest.phone) return false;
      return /^\d{10}$/.test(this.contactRequest.phone);
    },
    createdAt() {
      return moment.utc(this.contactRequest.createdAt).local().format('YYYY-MM-DD HH:mm');
    },
    createdAtFromNow() {
      return moment.utc(this.contactRequest.createdAt).local().fromNow();
    },
  },
  methods: {
    editContact() {
      this.$emit('editing', this.contactRequest.id);

      this.$modal.show({
        component: 'ContactRequestModal',
        props: {
          contactRequestId: this.contactRequest.id,
        },
        on: {
          hide: () => {
            this.$emit('edited', this.contactRequest.id);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
